var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5662_3643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0016 3.00682C15.0348 3.1779 15.0491 3.35373 15.0491 3.52481C15.0491 4.51327 15.0491 5.50173 15.0586 6.47593V7.52617H14.0479V6.05298C14.0479 5.8434 14.0482 5.63351 14.0485 5.42341V5.42208C14.0493 4.78941 14.0502 4.15473 14.0431 3.52006C14.0336 2.7312 13.6872 2.16093 12.9802 1.77125C12.7192 1.62868 12.4203 1.5574 12.0882 1.5574H3.73686C2.74989 1.5574 1.93375 2.27023 1.79614 3.24443C1.78665 3.33472 1.7819 3.42502 1.7819 3.52006V11.8459C1.7819 12.7441 2.36554 13.5092 3.23389 13.7468C3.39048 13.7943 3.56604 13.8133 3.77957 13.8133H7.72745V14.8208H3.72738C2.35606 14.816 1.16979 13.8989 0.847129 12.5825C0.824796 12.493 0.810872 12.3952 0.797442 12.3007L0.794933 12.2831L0.761719 12.0645L0.809169 2.98781C1.00372 1.80927 1.96222 0.830316 3.13424 0.611714C3.19909 0.598725 3.26172 0.590174 3.32517 0.581512C3.35457 0.577498 3.38415 0.57346 3.4142 0.568945L3.53283 0.554688H12.259L12.3918 0.573697C12.4219 0.57845 12.4519 0.582674 12.482 0.586898C12.5421 0.595346 12.6022 0.603795 12.6623 0.616467C13.8628 0.849325 14.8023 1.80927 15.0016 3.00682Z",
    fill: "#008331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4882 12.654L15.0113 14.1794C15.1964 14.3647 15.277 14.6261 15.2248 14.8732C15.1727 15.1108 15.0066 15.3057 14.7741 15.3912C14.7409 15.4055 14.7076 15.415 14.6744 15.4245L14.5748 15.4435L14.4324 15.4387C14.1904 15.396 14.0338 15.2534 13.901 15.1203C13.6889 14.9047 13.4746 14.6913 13.2611 14.4785C13.1547 14.3724 13.0482 14.2663 12.9425 14.1604L12.4253 13.6424C11.462 14.2222 10.4418 14.3695 9.38369 14.0844C8.45841 13.8325 7.71818 13.2907 7.18673 12.4734C6.1191 10.8339 6.44176 8.6526 7.9317 7.40277C9.40267 6.16245 11.5807 6.21472 12.9947 7.51683C14.4419 8.8522 14.6412 11.0667 13.4882 12.654ZM10.3849 13.1957C11.9603 13.1957 13.2035 11.9506 13.2082 10.3634C13.2082 9.6078 12.9188 8.89972 12.3873 8.36747C11.8606 7.83047 11.1583 7.53584 10.4134 7.53584H10.4086C8.86174 7.53584 7.59481 8.80467 7.59481 10.3634C7.59006 11.9221 8.83801 13.191 10.3802 13.1957H10.3849Z",
    fill: "#008331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7238 3.08301H3.09131V4.16651H12.7238V3.08301Z",
    fill: "#008331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21355 6.74197H3.09131V5.66797H6.21355V6.74197Z",
    fill: "#008331"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5662_3643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairHistory);
export default __webpack_public_path__ + "static/media/repair_history.4a27725ff535c10fd32bb6ecab06eaf5.svg";
export { ForwardRef as ReactComponent };